import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';

import { environment } from './../../environments/environment';

import { ZonaSearchModel } from './../models/user/zona-search.model';

import { Configurations } from "../core/configurations";

import {AuthService} from "./auth.service";

@Injectable()
export class ZoneService {
  //api base url
  APIZone = this.configuration.apiBaseUrlZone;
  //metodi
  MethodListaZona="RicercaListaZonePersona";

  constructor(private http: Http, private configuration: Configurations,private authenticationService:AuthService) {

 }

////////////////////////////////////////////////////////
//1- Lista zone utente
///////////////////////////////////////////////////////


  getListaZone(model: ZonaSearchModel): Observable<Response> {
    let searchParams = model || new ZonaSearchModel();
    return this.http.post(this.APIZone + this.MethodListaZona ,  searchParams)
    .map((r: any) => {
      return r.json();
    } ).catch((r: Response, o) => {
      if(r.status === 401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      return Observable.throw(r);
    });
    
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/zone.service.ts